export default function Hero() {
  const scrollToDownload = () => {
    const element = document.getElementById('download');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e718ba70a5f66fc90961a918874aec05.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Animated Network Pattern Overlay */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-20 w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-32 w-2 h-2 bg-blue-400 rounded-full animate-pulse delay-100"></div>
        <div className="absolute bottom-32 left-40 w-2 h-2 bg-cyan-400 rounded-full animate-pulse delay-200"></div>
        <div className="absolute bottom-20 right-20 w-2 h-2 bg-blue-400 rounded-full animate-pulse delay-300"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="mb-6">
          <span className="text-cyan-400 text-xs font-semibold tracking-[3px] uppercase">
            SECURE • PRIVATE • UNLIMITED
          </span>
        </div>

        <h1 className="mb-10">
          <div className="text-7xl font-extrabold text-white leading-tight mb-2">
            Your Digital
          </div>
          <div className="text-7xl font-extrabold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent leading-tight mb-2">
            Privacy Shield
          </div>
          <div className="text-7xl font-extrabold text-white leading-tight">
            Starts Here
          </div>
        </h1>

        <p className="text-xl text-white/80 max-w-3xl mx-auto mb-12 leading-relaxed">
          Experience military-grade encryption with lightning-fast speeds.<br />
          Browse anonymously from anywhere in the world.
        </p>

        <button
          onClick={scrollToDownload}
          className="px-10 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-lg font-bold rounded-full hover:shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 hover:-translate-y-1 flex items-center gap-3 mx-auto whitespace-nowrap"
        >
          Get Protected Now
          <i className="ri-arrow-right-line text-xl"></i>
        </button>
      </div>

      {/* Floating Geometric Shapes */}
      <div className="absolute top-20 left-10 w-32 h-32 border-2 border-cyan-400/20 rounded-full animate-pulse"></div>
      <div className="absolute bottom-32 right-16 w-24 h-24 border-2 border-blue-400/20 rotate-45 animate-pulse delay-200"></div>
    </section>
  );
}
